export enum AiAddendumState {
  AI_NOT_APPLICABLE = "AI_NOT_APPLICABLE",
  AI_TO_BE_APPROVED = "AI_TO_BE_APPROVED",
  AI_APPROVED = "AI_APPROVED",
  AI_APPROVED_PER_JPD = "AI_APPROVED_PER_JPD",
  AI_APPROVED_BY_DEFAULT = "AI_APPROVED_BY_DEFAULT",
  AI_APPROVED_BY_DEFAULT_PER_JPD = "AI_APPROVED_BY_DEFAULT_PER_JPD",
  AI_DISABLED = "AI_DISABLED",
  AI_DISABLED_BY_DEFAULT = "AI_DISABLED_BY_DEFAULT",
  AI_PERMANENTLY_REMOVED = "AI_PERMANENTLY_REMOVED",
}

export type AiSignatureOutcome = "RECORDED" | "VERIFIED" | "NOT_REQUIRED";

export interface ManageAccountAiStateRequest {
  accountNumber: number;
  currentState: AiAddendumState;
  requestedState: AiAddendumState;
}

export interface ManageAccountAiStateResponse {
  fromState: AiAddendumState;
  toState: AiAddendumState;
  signatureOutcome: AiSignatureOutcome;
}
